import { localizeNumber } from "@devforce/trailhead-client-locale";

import { label } from "./labelHelper";

export function pointLabel(points: number | undefined) {
  if (points !== undefined) {
    if (points === 0) {
      return label("zero", [points]);
    } else if (points === 1) {
      return label("one", [points]);
    } else {
      return label("many", [localizeNumber(points)]);
    }
  }
}

export function inProgressPointLabel(points: number | undefined) {
  if (points !== undefined) {
    if (points === 1) {
      return label("inProgressOne", [points]);
    } else {
      return label("inProgressMany", [localizeNumber(points)]);
    }
  }
}
